import Constant from '../lib/constant';
import axiosClient from './axiosClient';

const url = Constant.apiUrl + '/menus';
const menuApi = {
	get: (params) => {
		return axiosClient.get(url + '/admin/list', { params });
	},
	update: (body) => {
		return axiosClient.put(url + `/admin`, body);
	},
	delete: (id) => {
		return axiosClient.delete(url + `/${id}`);
	},
	getByKeyAdmin: (key) => {
		return axiosClient.get(url + `/admin?key=${key}`);
	},
};
export default menuApi;
